import React from "react";
import * as S from "./styled";
import FeaturedIcon from "../FeaturedIcon";
import Flex from "../Flex";
import { ProcessingButtonProps } from "./types";

type TProcessingButtonProps = ProcessingButtonProps & Omit<React.ButtonHTMLAttributes<HTMLElement>, "children">;

const ProcessingButton = ({
    title,
    subtitle,
    onClick,
    icon,
    active = false,
    disabled = false,
    ...buttonProps
}: TProcessingButtonProps): JSX.Element => {
    const handleClick: React.MouseEventHandler<HTMLElement> = event => {
        event.stopPropagation();
        onClick && onClick(event);
    };

    return (
        <S.Container
            disabled={disabled}
            data-active={active}
            onClick={disabled ? undefined : handleClick}
            {...buttonProps}
        >
            <FeaturedIcon color="primary" size="sm">
                {icon}
            </FeaturedIcon>
            <Flex gap={4} column>
                <S.PrimaryText>{title}</S.PrimaryText>
                {subtitle && <S.SecondaryText>{subtitle}</S.SecondaryText>}
            </Flex>
        </S.Container>
    );
};

export default ProcessingButton;
